import { render } from "./BaseListItemCard.vue?vue&type=template&id=a6638284"
import script from "./BaseListItemCard.vue?vue&type=script&lang=js"
export * from "./BaseListItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__